export default {"card":"Qm5cO","image":"a5sQm","heading":"jjkkI","text":"QmL8e","wrapper":"_1ALiz","linkButton":"_1S8tk"};